(() => {
  if (window.__vpInit) return;
  window.__vpInit = true;

  const ytId = (src) => {
    const m = String(src || '').match(/(?:youtube(?:-nocookie)?\.com\/(?:embed\/|watch\?v=|shorts\/)|youtu\.be\/)([\w-]{11})/);
    return m ? m[1] : '';
  };

  // Swap the cover for the real player on click.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.vp-embed__btn');
    if (!btn) return;
    const wrap = btn.closest('[data-vp-embed]');
    const id = wrap.dataset.vpEmbed;
    // Pause any other playing episode player on the page.
    document.querySelectorAll('.vp-embed iframe').forEach((f) => f.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&enablejsapi=1`;
    iframe.title = btn.getAttribute('aria-label') || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    btn.replaceWith(iframe);
    iframe.focus();
  });

  // maxresdefault doesn't exist for every video; YouTube serves a 120x90 grey placeholder instead.
  const fixPoster = (img) => {
    const swap = () => {
      if (img.dataset.fallback && (img.naturalWidth <= 120)) {
        img.src = img.dataset.fallback;
        delete img.dataset.fallback;
      }
    };
    if (img.complete) swap();
    else img.addEventListener('load', swap, { once: true });
    img.addEventListener('error', swap, { once: true });
  };

  const init = () => {
    document.querySelectorAll('.vp-embed__img[data-fallback]').forEach(fixPoster);

    const root = document.querySelector('[data-vp]');
    const shown = new Set(Array.from(document.querySelectorAll('[data-vp-embed]')).map((el) => el.dataset.vpEmbed));

    // Description: drop body embeds of videos already shown above, and turn
    // any other YouTube iframes into the same lightweight player.
    const desc = document.querySelector('[data-vp-desc-inner]');
    if (desc) {
      desc.querySelectorAll('iframe').forEach((f) => {
        const id = ytId(f.src || f.dataset.src);
        if (!id) return;
        if (shown.has(id)) {
          let parent = f.parentElement;
          f.remove();
          while (parent && parent !== desc && !parent.textContent.trim() && !parent.querySelector('img, iframe, .vp-embed')) {
            const next = parent.parentElement;
            parent.remove();
            parent = next;
          }
          return;
        }
        shown.add(id);
        const wrap = document.createElement('div');
        wrap.className = 'vp-embed';
        wrap.dataset.vpEmbed = id;
        wrap.innerHTML = `<button type="button" class="vp-embed__btn" aria-label="Play video"><img class="vp-embed__img" src="https://i.ytimg.com/vi/${id}/hqdefault.jpg" alt="" loading="lazy"><span class="vp-embed__play" aria-hidden="true"><svg viewBox="0 0 68 48" width="68" height="48"><path class="vp-embed__play-bg" d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.2.4 34 .4 34 .4s-21.2 0-26.5 1.3a8.5 8.5 0 0 0-6 6C.2 13 .2 24 .2 24s0 11 1.3 16.3a8.5 8.5 0 0 0 6 6C12.8 47.6 34 47.6 34 47.6s21.2 0 26.5-1.3a8.5 8.5 0 0 0 6-6C67.8 35 67.8 24 67.8 24s0-11-1.3-16.3z"/><path fill="#fff" d="M45 24 27 14v20z"/></svg></span></button>`;
        f.replaceWith(wrap);
      });
      desc.querySelectorAll('a[href]').forEach((a) => {
        if (a.hostname && a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noopener'; }
      });

      // Long descriptions collapse behind "Show more", like a video description.
      const box = desc.closest('[data-vp-desc]');
      const more = box.querySelector('[data-vp-more]');
      if (desc.scrollHeight > 300) {
        box.classList.add('is-collapsible');
        more.hidden = false;
        more.addEventListener('click', () => {
          const open = box.classList.toggle('is-open');
          more.textContent = open ? 'Show less' : 'Show more';
          more.setAttribute('aria-expanded', open);
        });
      }
    }

    // Share: native sheet on phones, copy link elsewhere.
    document.querySelectorAll('[data-vp-share]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const data = { title: btn.dataset.title, url: btn.dataset.url };
        const label = btn.querySelector('[data-vp-share-label]');
        if (navigator.share && matchMedia('(pointer: coarse)').matches) {
          try { await navigator.share(data); } catch (e) {}
          return;
        }
        try {
          await navigator.clipboard.writeText(data.url);
          label.textContent = 'Link copied';
          setTimeout(() => (label.textContent = 'Share'), 2000);
        } catch (e) {
          window.prompt('Copy this link', data.url);
        }
      });
    });

    // More episodes.
    document.querySelectorAll('[data-vp-more-src]').forEach(async (sec) => {
      try {
        const res = await fetch(sec.dataset.vpMoreSrc);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = doc.querySelector('.vp-more__grid');
        if (!grid) return;
        const limit = parseInt(sec.dataset.vpMoreLimit, 10) || 4;
        const cards = Array.from(grid.children).filter((li) => li.dataset.id !== sec.dataset.vpCurrent);
        grid.replaceChildren(...cards.slice(0, limit));
        if (!grid.children.length) return;
        sec.querySelector('[data-vp-more-target]').replaceChildren(grid);
        sec.hidden = false;
      } catch (e) {}
    });

    if (root) root.dataset.vpReady = 'true';
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
